import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import Map from '../Map'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const defaultProperties = {
    // Default values used if they don't come from Unity
    bfsIdParamName: tenant?.lang === 'fr' ? 'commune' : 'gemeinde',
  }
  const propertiesWithDefaults = { ...defaultProperties, ...properties }
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <TextWidthExtended>
        <Map colorMode={colorMode} locale={tenant?.lang ?? 'de'} bfsIdChangedEventName={properties?.bfsIdChangedEventName} bfsIdParamName={propertiesWithDefaults.bfsIdParamName}/>
      </TextWidthExtended>
    </AppContainer>
  )
}
const AppContainer = styled.div`
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
